// TosConsentCard on the wall — Stage Light tokens (BRIEF § Chrome: `--tl-*`, the implementation of
// what the brief prose calls `--g`/`--bd`/`--tx`/etc.), the same set `Column.module.scss` and
// `Sheet.module.scss` already draw from. No button here — the wall's own verb is the second press
// (plan 2026_09_01_tos_gate.md §8.2/§8.4).

.card {
    display: flex;
    flex-direction: column;
    gap: 10px;
    border: 1px solid var(--tl-border-strong);
    background: var(--tl-surface);
    border-radius: 12px;
    padding: 12px 14px;
}

.checkbox {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    cursor: pointer;
    font-family: var(--tl-font);
    font-size: 13px;
    color: var(--tl-muted);
    line-height: 1.5;
    text-align: left;

    input[type='checkbox'] {
        margin-top: 3px;
        width: 15px;
        height: 15px;
        flex-shrink: 0;
        accent-color: var(--tl-accent);
        cursor: pointer;
    }

    a {
        color: var(--tl-text);
        text-decoration: none;
        border-bottom: 1px solid var(--tl-border-strong);

        &:hover {
            color: var(--tl-accent);
            border-bottom-color: var(--tl-accent);
        }
    }
}
